export default {
    HOME: [
        {
            name: 'Ver indicadores de inicio',
            code: 'view-summary',
            tooltip: 'Muestra en Inicio las tarjetas de facturación del mes, ticket promedio, pedidos del día y utilidad neta.',
        },
        {
            name: 'Ver alerta de inventario bajo',
            code: 'view-security-stock',
            tooltip: 'Muestra en Inicio los productos con poco stock o agotados.',
        },
        {
            name: 'Ver productos más vendidos',
            code: 'view-top-products',
            tooltip: 'Muestra en Inicio los productos que más se venden.',
        },
        {
            name: 'Ver utilidad vs facturación',
            code: 'view-utility-billing',
            tooltip: 'Además del gráfico de Inicio, permite ver montos, costos y utilidad en Registros de pedidos, Resumen financiero y los reportes descargables.',
        },
        {
            name: 'Agregar sugerencias',
            code: 'send-suggestion',
            tooltip: 'Muestra en Inicio el formulario para enviarle sugerencias al equipo de Fina.',
        },
    ],
    POS: [
        {
            name: 'Ver registros de pedidos',
            code: 'view-sales-registries',
            tooltip: 'Permite ver la lista de pedidos finalizados, el detalle de cada uno y el reporte de pedidos.',
        },
        {
            name: 'Crear pedidos y usar mesas',
            code: 'open-direct-and-open-sales',
            tooltip: 'Permite entrar a Nuevo pedido y a Mesas, crear pedidos y agregar o quitar productos.',
        },
        {
            name: 'Ver precios de venta por canal',
            code: 'view-sales-channels',
            tooltip: 'Permite entrar a la pantalla Precios de Venta y ver los canales y sus precios.',
        },
        {
            name: 'Agregar canales de venta',
            code: 'add-sales-channels',
            tooltip: 'Permite crear canales de venta nuevos (por ejemplo, Delivery o Mayorista).',
        },
        {
            name: 'Editar canales de venta',
            code: 'edit-sales-channels',
            tooltip: 'Permite cambiar los precios de venta de cada canal y activar o desactivar productos en cada canal.',
        },
        {
            name: 'Finalizar pedidos',
            code: 'end-sales',
            tooltip: 'Permite finalizar los pedidos: cobrarlos y cerrarlos.',
        },
        {
            name: 'Realizar ventas a crédito',
            code: 'create-credit-sales',
            tooltip: 'Permite al usuario seleccionar Crédito o Cuenta por cobrar como método de pago al crear un pedido.',
        },
        {
            name: 'Eliminar pedido',
            code: 'delete-sale',
            tooltip: 'Permite eliminar un pedido ya finalizado desde Registros de pedidos. No aplica a pedidos con factura fiscal.',
        },
        {
            name: 'Realizar devoluciones',
            code: 'edit-sale',
            tooltip: 'Permite registrar devoluciones y cambios de productos en pedidos ya finalizados. Si el pedido tiene factura fiscal, también hace falta «Generar factura fiscal».',
        },
        {
            name: 'Cambiar precio en el momento de la venta',
            code: 'edit-selling-price-in-pos',
            tooltip: 'Permite modificar el precio de un producto sólo en ese pedido, al momento de cobrarlo. No cambia el precio guardado del producto.',
        },
        {
            name: 'Registrar pedidos con fecha anterior',
            code: 'edit-sale-date',
            tooltip: 'Permite elegir un día anterior a hoy como fecha del pedido al finalizarlo. Sin este permiso, los pedidos se registran con la fecha de hoy.',
        },
        {
            name: 'Ver disponibilidad de productos',
            code: 'view-availability',
            tooltip: 'Muestra cuántas unidades quedan de cada producto al vender. Los productos agotados se marcan siempre, aunque no se tenga este permiso.',
        },
        {
            name: 'Ver registros de cierre de caja',
            code: 'view-cashbox-registries',
            tooltip: 'Permite ver el historial de aperturas y cierres de caja y el detalle de cada uno.',
        },
        {
            name: 'Abrir caja',
            code: 'open-cashbox',
            tooltip: 'Permite abrir la caja al iniciar el turno. Sólo aplica si el comercio tiene activado el cierre de caja.',
        },
        {
            name: 'Cerrar caja',
            code: 'close-cashbox',
            tooltip: 'Permite cerrar la caja y generar el reporte de cierre. Sólo aplica si el comercio tiene activado el cierre de caja.',
        },
    ],
    FISCAL_INVOICE: [
        {
            name: 'Generar factura fiscal',
            code: 'generate-fiscal-invoice',
            tooltip:
                'Permite emitir facturas fiscales, notas de crédito y débito, anular documentos y sacar el Reporte Z. Sin este permiso tampoco se pueden hacer devoluciones de pedidos facturados.',
        },
    ],
    INVENTORY: [
        {
            name: 'Ver inventario',
            code: 'view-inventory',
            tooltip: 'Permite ver la lista de productos del inventario, su detalle y el reporte de inventario.',
        },
        {
            name: 'Sacar de inventario',
            code: 'out-inventory',
            tooltip: 'Permite sacar unidades del inventario manualmente, por ejemplo por merma, daño o consumo interno.',
        },
        {
            name: 'Fabricar recetas y combos',
            code: 'convert-items',
            tooltip: 'Permite fabricar recetas o armar combos. Al hacerlo se descuentan del inventario los ingredientes o productos que los componen.',
        },
        {
            name: 'Ver costos y valor del inventario',
            code: 'view-unit-price',
            tooltip: 'Muestra el costo de cada producto y el valor total del inventario. Es necesario para el ingreso de inventario.',
        },
        {
            name: 'Crear y editar items',
            code: 'edit-items',
            tooltip: 'Permite crear productos y editar sus datos.',
        },
        {
            name: 'Eliminar items',
            code: 'delete-items',
            tooltip: 'Permite eliminar productos, sus variaciones y los lotes que quedaron en cero.',
        },
        {
            name: 'Editar y dividir lotes',
            code: 'edit-split-batches',
            tooltip: 'Permite editar, dividir y unir lotes de un mismo producto.',
        },
        {
            name: 'Editar costo unitario de lotes',
            code: 'edit-batch-unit-cost',
            tooltip: 'Permite modificar el costo unitario de un lote ya registrado.',
        },
        {
            name: 'Ver registros de inventario',
            code: 'view-inventory-registries',
            tooltip: 'Permite ver el historial de entradas, salidas y traslados de inventario.',
        },
        {
            name: 'Ver recetas y combos',
            code: 'view-combined-products',
            tooltip: 'Permite ver la sección Recetas/Combos.',
        },
        {
            name: 'Crear y editar recetas y combos',
            code: 'create-edit-combined-products',
            tooltip: 'Permite crear recetas y combos nuevos y modificar los existentes.',
        },
        {
            name: 'Eliminar recetas y combos',
            code: 'delete-combined-products',
            tooltip: 'Permite eliminar recetas y combos.',
        },
        {
            name: 'Ver servicios',
            code: 'view-services',
            tooltip: 'Permite ver el catálogo de servicios del comercio.',
        },
        {
            name: 'Crear y editar servicios',
            code: 'create-edit-services',
            tooltip: 'Permite crear servicios nuevos y editar los existentes.',
        },
        {
            name: 'Eliminar servicios',
            code: 'delete-services',
            tooltip: 'Permite eliminar servicios del catálogo.',
        },
        {
            name: 'Trasladar inventario entre ubicaciones',
            code: 'transfer-inventory',
            tooltip: 'Permite mover unidades de un producto de una ubicación a otra.',
        },
    ],
    BANK_ACCOUNTS: [
        {
            name: 'Ver cuentas bancarias',
            code: 'view-bank-accounts',
            tooltip: 'Permite ver las cuentas bancarias, los movimientos de cada una y los reportes de cuentas y métodos de pago.',
        },
        {
            name: 'Agregar cuentas bancarias',
            code: 'add-bank-accounts',
            tooltip: 'Permite agregar cuentas bancarias nuevas.',
        },
        {
            name: 'Eliminar cuentas bancarias',
            code: 'delete-bank-accounts',
            tooltip: 'Permite eliminar una cuenta bancaria. La caja de efectivo y las cuentas del sistema no se pueden eliminar.',
        },
        {
            name: 'Transferir entre cuentas bancarias',
            code: 'transfer-between-bank-accounts',
            tooltip: 'Permite mover dinero de una cuenta a otra.',
        },
        {
            name: 'Fondear cuentas bancarias',
            code: 'fund-bank-accounts',
            tooltip: 'Permite registrar manualmente un ingreso de dinero en una cuenta.',
        },
        {
            name: 'Retirar de cuentas bancarias',
            code: 'withdraw-from-bank-accounts',
            tooltip: 'Permite registrar manualmente una salida de dinero de una cuenta.',
        },
        {
            name: 'Ver registros de cuentas bancarias',
            code: 'view-bank-account-registries',
            tooltip: 'Permite ver el historial de movimientos de todas las cuentas juntas.',
        },
        {
            name: 'Ver cuentas por cobrar y por pagar',
            code: 'view-pending-accounts',
            tooltip: 'Permite ver las cuentas por cobrar y por pagar y su resumen en Inicio.',
        },
        {
            name: 'Gestionar, cobrar y pagar cuentas pendientes',
            code: 'create-edit-pending-accounts',
            tooltip: 'Permite crear, editar y eliminar cuentas por cobrar y por pagar, y registrar sus cobros y pagos (esto mueve dinero en las cuentas bancarias).',
        },
        {
            name: 'Eliminar registro bancario',
            code: 'delete-bank-account-registries',
            tooltip: 'Permite eliminar, desde el historial de la cuenta, el pago registrado de un gasto fijo.',
        },
    ],
    COMMERCE: [
        {
            name: 'Ver configuración',
            code: 'view-commerce',
            tooltip: 'Permite entrar a la sección Configuración: preferencias, usuarios, descuentos, planes y más. Lo que se puede cambiar ahí depende de los otros permisos de este grupo.',
        },
        {
            name: 'Crear y editar usuarios',
            code: 'create-and-edit-users',
            tooltip: 'Permite crear, editar, activar, desactivar y eliminar usuarios, cambiar sus permisos y comprar cupos. Con este permiso el usuario aparece como Administrador.',
        },
        {
            name: 'Editar métodos de inventario',
            code: 'edit-inventory-methods',
            tooltip: 'Permite elegir cómo se calcula el costo del inventario (FIFO o promedio ponderado) y si los precios se calculan por utilidad o por margen.',
        },
        {
            name: 'Editar uso de IGTF e IVA',
            code: 'edit-use-igtf-iva',
            tooltip: 'Permite activar o desactivar el IVA, el IGTF y la condición de agente de retención.',
        },
        {
            name: 'Editar datos del comercio',
            code: 'edit-organization-data',
            tooltip: 'Permite cambiar el nombre, dirección, teléfono, RIF y título de los recibos del comercio.',
        },
        {
            name: 'Editar tasa de cambio',
            code: 'edit-exchange-rate',
            tooltip: 'Permite cambiar la tasa del comercio en Preferencias y modificar la tasa de un pedido al cobrarlo. Sin este permiso se usa la tasa oficial.',
        },
        {
            name: 'Crear y editar cargos extra',
            code: 'edit-extra-charges',
            tooltip: 'Permite definir los cargos extra de cada miembro del personal (por ejemplo, comisión del mesero o tarifa del motorizado).',
        },
        {
            name: 'Editar gastos fijos',
            code: 'edit-fixed-variable',
            tooltip: 'Permite editar los gastos fijos del comercio.',
        },
        {
            name: 'Habilitar estatus de pedido',
            code: 'edit-status-POS',
            tooltip: 'Permite activar el seguimiento por estatus de los pedidos (pendiente, en proceso, procesado) y el uso de comandas.',
        },
        {
            name: 'Crear y editar métodos de pago',
            code: 'create-edit-payment-methods',
            tooltip: 'Permite crear métodos de pago, editarlos y vincularlos a una cuenta bancaria.',
        },
        {
            name: 'Crear y editar personal',
            code: 'create-edit-staff',
            tooltip: 'Permite registrar y editar al personal al que se le asignan cargos extra en los pedidos, como meseros o motorizados.',
        },
        {
            name: 'Configurar el cierre de caja',
            code: 'enable-cashbox',
            tooltip: 'Permite activar o desactivar el cierre de caja y elegir qué métodos de pago se cuadran en él.',
        },
        {
            name: 'Eliminar ubicaciones de inventario',
            code: 'remove-inventory-location',
            tooltip: 'Permite eliminar una ubicación de inventario desde Preferencias > Avanzado.',
        },
    ],
    FINANCIAL_SUMMARY: [
        {
            name: 'Ver resumen financiero',
            code: 'view-utility-loss',
            tooltip: 'Permite ver la pantalla de Utilidad/Pérdida y el costo de cada pedido en los reportes.',
        },
        {
            name: 'Ver y generar reportes',
            code: 'generate-reports',
            tooltip: 'Permite entrar a Reportes y descargarlos. Las pestañas que aparecen dependen de los otros permisos del usuario (pedidos, cuentas o inventario).',
        },
    ],
    FIXED_AND_VARIABLE_EXPENSES: [
        {
            name: 'Crear gastos fijos y variables',
            code: 'create-fixes-variables-expenses',
            tooltip: 'Permite registrar gastos fijos y variables, también desde el botón «Agregar gasto» de la barra superior.',
        },
        {
            name: 'Ver gastos fijos y variables',
            code: 'view-fixed-variable-expenses',
            tooltip: 'Permite ver los gastos fijos y variables del comercio.',
        },
        {
            name: 'Eliminar gastos fijos y variables',
            code: 'delete-fixed-variable-expenses',
            tooltip: 'Permite eliminar gastos registrados.',
        },
        {
            name: 'Editar y pagar gastos fijos',
            code: 'edit-fixed-variable-expenses',
            tooltip: 'Permite editar los gastos fijos y registrar su pago, que descuenta el dinero de una cuenta.',
        },
    ],
    MARKETING: [
        {
            name: 'Ver campañas',
            code: 'view-campaign',
            tooltip: 'Permite ver las campañas de mensajes y los segmentos de clientes.',
        },
        {
            name: 'Ver clientes',
            code: 'view-clients',
            tooltip: 'Permite ver el listado de clientes del comercio.',
        },
        {
            name: 'Crear y editar filtros',
            code: 'create-edit-filters',
            tooltip: 'Permite crear y editar los segmentos de clientes a los que se envían campañas.',
        },
        {
            name: 'Crear y editar campañas',
            code: 'create-edit-campaign',
            tooltip: 'Permite crear campañas de mensajes. Al crear una campaña, los mensajes se envían a los clientes.',
        },
        {
            name: 'Cargar clientes',
            code: 'bulk-customers',
            tooltip: 'Permite cargar clientes desde un archivo y también eliminarlos de forma masiva.',
        },
    ],
    STATISTICS: [
        {
            name: 'Ver estadísticas',
            code: 'view-statistics',
            tooltip: 'Permite ver la sección Estadísticas.',
        },
    ],
};
